import { useBrand, useCampaign, useProject, type CampaignParams as Params } from '@round/creatorbase-helpers/api-hooks';
import { isNumber } from 'utility/utility';

export default function useCampaignData(id: number | null | undefined, params: Params = {}) {
    const campaignQuery = useCampaign(id, params);
    const projectQuery = useProject(campaignQuery.data?.project_id, {
        enabled: isNumber(campaignQuery.data?.project_id),
    });

    const brandQuery = useBrand(projectQuery.data?.brand_id, { enabled: isNumber(projectQuery.data?.brand_id) });

    return {
        campaign: campaignQuery.data,
        project: projectQuery.data,
        brand: brandQuery.data,
        isLoading: campaignQuery.isLoading || projectQuery.isLoading || brandQuery.isLoading,
    };
}
